import React from 'react'
import "../assets/css/AdminCommon.css";

const Pagination_2 = ({filterDataInput, setFilterDataInput, showNext=true}) => {
    const handleLimitChange = (e) => {
        setFilterDataInput({ ...filterDataInput, limit: Number(e.target.value), page: 0 });
    };

    const handlePreviousPage = () => {
        setFilterDataInput({ ...filterDataInput, page: Number(filterDataInput.page - 1) });
    };

    const handleNextPage = () => {
        setFilterDataInput({ ...filterDataInput, page: Number(filterDataInput.page + 1) });
    };

    return (
        <>
            <div className='pagination-v4'>
                <div className="pagination-info-v4">
                    <label>Rows</label>
                    <select 
                        value={filterDataInput.limit} 
                        onChange={handleLimitChange}
                        className="pagination-select-v4"
                    >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                        <option value={1500}>1500</option>
                    </select>
                    <span>Page {filterDataInput.page + 1}</span>
                </div>

                <div className="pagination-buttons-v4">
                    {filterDataInput.page > 0 && (
                        <button
                            className='btn-secondary-v4'
                            onClick={handlePreviousPage}
                        >
                            Previous
                        </button>
                    )}

                    {showNext && (
                        <button
                            className='btn-secondary-v4'
                            onClick={handleNextPage}
                        >
                            Next
                        </button>
                    )}
                </div>
            </div>
        </>
    )
}

export default Pagination_2